<!--  -->
<template>
  <ul class="small-nav" v-if="value">
    <li
      v-for="(nav,index) in navList"
      :key="index"
      @click.stop="handleNavClick(nav)">
      <div class="icon">
        <cc-svg-icon :icon-class="nav.icon" size="22"></cc-svg-icon>
      </div>
      <p class="nav-name">{{nav.name}}</p>
      <span
        v-if="nav.info"
        :class="[totalNum>10?'fz6':'fz10']"
        class="nav-info"
      >{{totalNum>99?" 99+":totalNum}}</span>
    </li>
  </ul>
</template>

<script>
import { mapGetters } from 'vuex'
import { ResultCode } from '~const/ResultCode'
export default {
  name: 'cc-small-nav',
  components: {},

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      navList: [
        {
          name: '首页',
          icon: 'home',
          path: '/home',
          redirect: false,
          active: false
        },
        {
          name: '快捷采购',
          icon: 'feature',
          path: '/categorylist',
          redirect: false,
          active: false
        },
        {
          name: '采购车',
          icon: 'car',
          path: '/shopping-cart/purchase',
          redirect: false,
          info: true,
          active: false
        },
        {
          name: '管理中心',
          icon: 'me',
          path: '/management',
          redirect: false,
          active: false
        }
      ]
    }
  },

  computed: {
    ...mapGetters(['getGoodsTotalNum', 'getLoginStatus', 'getCartnum']),
    totalNum () {
      // return 0
      if (this.islogin.toString() === '0') {
        return 0
      } else {
        if (this.role.toString() === '3') {
          return this.getGoodsTotalNum.quantity
        } else {
          return this.getCartnum
        }
      }
    }
  },

  watch: {
    getLoginStatus: {
      deep: true,
      immediate: true,
      handler (newValue, oldValue) {
        if (newValue) {
          let { status, data } = newValue
          this.islogin = data.member_id
          this.role = data.role
          if (status === ResultCode.SUCCESS) {
            if (data.member_id.toString() !== '0') {
              // 登录角色 1 采购商 2 供应商   3 分销商
              if (['1', '2'].includes(data.role.toString())) {
                this.navList[2].name = '采购车'
                this.navList[2].path = '/shopping-cart/purchase'
              } else {
                this.navList[2].name = '采购单'
                this.navList[2].path = '/shopping-cart/distributor'
              }
            }
          }
        }
      }
    }
  },

  created () {},
  async mounted () {
    await this.$nextTick()
    document.body.addEventListener('click', this.bindBodyEvent, false)
  },
  beforeDestroy () {
    document.body.removeEventListener('click', this.bindBodyEvent)
  },
  methods: {
    bindBodyEvent () {
      if (this.value) {
        this.$emit('input', false)
      }
    },
    handleNavClick (nav) {
      /**
       * @description 兼容老页面。老页面使用 localtion 跳转，新页面使用router 跳转
       */
      if (nav.redirect) {
        location.href = nav.path
      } else {
        this.$router.replace(nav.path)
      }
    }
  }
}

</script>
<style lang='scss' scoped>
.small-nav{
  position: fixed;
  z-index: 20;
  top: 35px;
  right: 10px;
  width: 130px;
  height: 164px;
  background:rgba(255,255,255,1);
  box-shadow:0px 5px 17px 0px rgba(144, 143, 143, 0.35);
  border-radius:2px;
  li{
    display: flex;
    justify-content: space-between;
    height: 25%;
    position: relative;
    .icon{
      flex: 1;
      @include center();
      color:#C2C2C2;
    }
    .nav-name{
      width: 82px;
      height: 40px;
      box-sizing: border-box;
      display: flex;
      justify-content: flex-start;
      padding-left: 15px;
      align-items: center;
      font-size: 12px;
      color: #555555;
    }
    .nav-info {
      background: var(--APP_theme_color);
      display: inline-block;
      height: 16px;
      width: 16px;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 8px;
      position: absolute;
      top: 5px;
      left: 40px;
    }
  }
  li:not(:last-child){
      border-bottom:1px solid rgba(238,238,238,1);
  }
  &::before{
    content: '';
    display: inline-block;
    position: absolute;
    top: -5px;
    right: 5px;
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-bottom: 5px solid rgba(255,255,255,1);
  }
}
</style>
